import enviro from 'enviro';
import { getFullUrl } from 'hubspot-url-utils';
import Logger from '../lib/Logger';
import { Environment } from '../types/Environment';
import { normalizeUrl } from './normalizeUrl';
const LOG = Logger.getLogger('urls');
const getHubletUrl = (subDomainPrefix, hublet) => {
  const overrideConfig = {};
  if (hublet) {
    overrideConfig.hubletOverride = hublet;
  }
  return getFullUrl(subDomainPrefix, overrideConfig);
};
export const getHubletAppUrl = hublet => getHubletUrl('app', hublet);
export const getHubletApiUrl = hublet => getHubletUrl('app-api', hublet);
export const getAppUrl = () => {
  const prefix = !enviro.deployed() ? Environment.Local : 'app';
  return getFullUrl(prefix, {});
};
export const isHubSpotHost = url => {
  try {
    const {
      hostname
    } = new URL(url);
    return /(^|\.)(app|local|mcp)[^.]*\.hubspot(qa)?\.com$/.test(hostname);
  } catch (_unused) {
    return false;
  }
};
export const getUrlData = stringifiedUrl => {
  let urlData = {};
  if (!stringifiedUrl || stringifiedUrl === '') {
    return urlData;
  }
  try {
    const normalizedUrl = normalizeUrl(stringifiedUrl);
    const url = new URL(normalizedUrl);
    const {
      hostname,
      pathname,
      href,
      search
    } = url;
    urlData = {
      hostName: hostname,
      pathName: pathname,
      href,
      search
    };
  } catch (error) {
    LOG.info('Invalid url', {
      extra: stringifiedUrl
    });
  }
  return urlData;
};